import css from 'styled-jsx/css';
import classnames from 'classnames';
import PropTypes from 'prop-types';

import { colors } from '../common/Theme';

const linkHeight = '24px';
const nextLinkStyles = css`
  .link {
    display: inline-flex;
    margin: 0;
    padding: 0;
    color: ${colors.ywgPrimary};
    align-items: center;
    margin-top: 24px;
  }
  .link-arrow {
    display: flex;
    margin: 0 12px;
    padding: 0;
    width: ${linkHeight};
    height: ${linkHeight};
    justify-content: center;
    align-items: center;
    color: white;
    text-align: center;
    background-color: ${colors.ywgPrimary};
    border-radius: 50%;
    box-shadow: 0 0 24px 0 ${colors.ywgPrimary};
  }
`;

const ContinueLink = ({ href, onClick, className }) => {
  return (
    <>
      <a
        href={href}
        onClick={onClick}
        className={classnames('link', className)}
      >
        <span>Continuer</span>
        <div className="link-arrow">
          <svg width="9" height="8" viewBox="0 0 18 16">
            <use href="#svg-arrow-right" fill="white" />
          </svg>
        </div>
      </a>
      <style jsx>{nextLinkStyles}</style>
    </>
  );
};

ContinueLink.propTypes = {
  href: PropTypes.string.isRequired,
  className: PropTypes.string,
  onClick: PropTypes.func
};

export default ContinueLink;
